import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Refugio Digital',
  description: 'Te unes a Affiliate Wave y accedes al material desde la seguridad de tu hogar.'
}, {
  number: '02',
  title: 'Construcción Silenciosa',
  description: 'Aplicas los recursos de IA para crear tu flujo de ventas sin usar tu nombre o rostro.'
}, {
  number: '03',
  title: 'Tranquilidad Familiar',
  description: 'Empiezas a generar ingresos que no dependen de que salgas a la calle, eliminando el riesgo de exposición diaria.'
}];
export function HowItWorks() {
  return <section className="bg-[#0a0a0a] py-24 border-t border-white/5" data-id="element-96">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-99">
            Tres pasos hacia tu tranquilidad
          </h2>
          <div className="w-24 h-1 bg-[#d4a437] mx-auto rounded-full opacity-50" data-id="element-100"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-101">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-gradient-to-r from-transparent via-[#d4a437]/30 to-transparent z-0" data-id="element-102"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-103">
              <div className="w-24 h-24 rounded-full bg-[#111] border-2 border-[#d4a437] flex items-center justify-center mb-6 shadow-[0_0_15px_rgba(212,164,55,0.2)]" data-id="element-104">
                <span className="font-serif text-3xl font-bold text-[#d4a437]" data-id="element-105">
                  {step.number}
                </span>
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-106">
                {step.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed max-w-sm" data-id="element-107">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}